// export { default as ToastStore } from './_store'

// export { default as Message } from './_message'
// export type { IMessage } from './_message'

export { default as MessageStore } from './store'
export type { Message } from './store'
